<template lang="pug">
  .update-prices
    .title Precios Promoción
    .update-prices-list(v-if="brands && brands.length > 0")
      .update-prices-item(v-for="brand in brands" :key="brand")
        .dark {{ brand }}
        .field
          label Porcentaje normal (%)
          input(type="number" v-model.number="form[brand].percentageNormal" min="0" max="100" placeholder="ej: 30")
        .field
          label Porcentaje clearance (%)
          input(type="number" v-model.number="form[brand].percentageClearance" min="0" max="100" placeholder="opcional")
        .preview(v-if="form[brand].percentageNormal > 0")
          span Precio normal queda al {{ 100 - form[brand].percentageNormal }}% del original
        div
          shActionButton(text="Actualizar" :action="update" :params="[brand]" :principalColor="true")
</template>

<script>
import gqlUpdatePrices from '@/graphql/updatePrices'
import gql from '@my/graphql'
import shActionButton from '@/components/elements/ActionButton'
import modals from '@my/store/modals'

export default {
  name: 'UpdatePrices',

  components: { shActionButton },

  data () {
    return {
      form: {}
    }
  },

  mounted () {
    if (this.brands && this.brands.length > 0) {
      this.initForm()
    }
  },

  computed: {
    brands () {
      return this.$store.state.variables.brands
    }
  },

  watch: {
    brands () {
      this.initForm()
    }
  },

  methods: {
    initForm () {
      this.brands.forEach(brand => {
        if (!this.form[brand]) {
          this.$set(this.form, brand, { percentageNormal: null, percentageClearance: null })
        }
      })
    },

    async update (brand) {
      const { percentageNormal, percentageClearance } = this.form[brand]

      if (!percentageNormal && percentageNormal !== 0) {
        modals.showMessage({ message: 'El porcentaje normal es obligatorio', type: 'error' })
        return
      }

      const variables = { brand, percentageNormal }
      if (percentageClearance != null && percentageClearance !== '') {
        variables.percentageClearance = percentageClearance
      }

      const { data } = await gql.mutate(gqlUpdatePrices.UPDATE_BY_BRAND, variables)
      const count = data.updatePricesByBrand

      modals.showMessage({ message: `${count} productos actualizados en ${brand}`, type: 'ok' })
    }
  }
}
</script>

<style lang="stylus" scoped>
.update-prices-list
  display flex
  flex-direction column
  gap 1rem
  align-items center
  justify-content center
  padding 1rem

.update-prices-item
  display flex
  flex-direction column
  gap 1rem
  align-items center
  justify-content center
  padding 1.5rem
  border-radius 1rem
  border 1px solid rgba(0, 0, 0, 0.1)
  width 100%
  max-width 400px

.field
  display flex
  flex-direction column
  gap 0.3rem
  width 100%
  input
    padding 0.4rem 0.6rem
    border 1px solid rgba(0, 0, 0, 0.2)
    border-radius 0.3rem
    width 100%

.preview
  font-size 0.85rem
  opacity 0.7
</style>



// WEBPACK FOOTER //
// src/components/pages/updatePrices/UpdatePrices.vue